import React from "react";
import checkCircle from "@src/assets/svg/check-circle.svg";
import styles from "./checked-unordered-list.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "checked-unordered-list";

interface CheckedUnorderedListPropTypes {
  list: string[];
}

export const CheckedUnorderedList = ({
  list,
}: CheckedUnorderedListPropTypes) => {
  const i18n = useI18N();

  const texts = {
    checkedCircleAltText: i18n(
      "modules.checkedUnorderedList.checkedCircleAltText",
    ),
  };
  return (
    <div className={styles[cssClassName]}>
      <ul className={styles[`${cssClassName}__list`]}>
        {list.map((item, index) => (
          <li className={styles[`${cssClassName}__list-element`]} key={index}>
            <img
              src={checkCircle}
              alt={texts.checkedCircleAltText}
              className={styles[`${cssClassName}__icon`]}
            />
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};
